import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import EtaHint from '../components/EtaHint';
import { pushToast } from '../hooks/useToasts';
// Resoluciones del PDF §3 — más alta = mejor preservación por YouTube.
const RESOLUTIONS = [
    { label: '720p', w: 1280, h: 720 },
    { label: '1080p', w: 1920, h: 1080 },
    { label: '1440p', w: 2560, h: 1440 },
    { label: '2160p (4K)', w: 3840, h: 2160 },
];
export default function Calibrate() {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [width, setWidth] = useState(3840);
    const [height, setHeight] = useState(2160);
    const [repeat, setRepeat] = useState(24);
    const [fps, setFps] = useState(24);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const setResolution = (w, h) => {
        setWidth(w);
        setHeight(h);
    };
    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await api.post('/jobs/calibrate', { width, height, repeat, fps });
            pushToast({ kind: 'info', title: t('jobLaunched.title'), msg: t('jobLaunched.msg') });
            nav('/dashboard');
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "prose", children: [_jsx("h1", { children: t('calibrate.title') }), _jsx("p", { className: "muted", children: t('calibrate.subtitle') }), _jsxs("form", { onSubmit: onSubmit, className: "card form-card", children: [_jsxs("label", { children: [t('calibrate.resolution'), _jsx("div", { className: "chip-row", children: RESOLUTIONS.map((r) => (_jsx("button", { type: "button", className: `chip ${width === r.w && height === r.h ? 'active' : ''}`, onClick: () => setResolution(r.w, r.h), children: r.label }, r.label))) })] }), _jsxs("div", { className: "grid-2", children: [_jsxs("label", { children: [t('calibrate.repeat'), _jsx("input", { type: "number", min: 1, max: 240, value: repeat, onChange: (e) => setRepeat(Number(e.target.value)) })] }), _jsxs("label", { children: [t('calibrate.fps'), _jsx("input", { type: "number", min: 1, max: 120, value: fps, onChange: (e) => setFps(Number(e.target.value)) })] })] }), error && _jsx("p", { className: "error", children: error }), _jsx(EtaHint, { kind: "calibrate" }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy, children: busy ? t('common.loading') : t('calibrate.submit') })] })] }));
}
